module.exports = __webpack_public_path__ + "kibervarnost/media/naredi-backup.0830c8e7.mp4";